import api from '..';
import useResourceList from './useResourceList';
import useQuery from './useQuery';

export const useTagList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'tags', api: api.tags }, queryVariables, queryConfig);

  return {
    tags: queryResult.resolvedData,
    latestTags: queryResult.latestData,
    ...queryResult,
  };
};

export const useTag = (id, queryConfig = {}) => {
  const queryResult = useQuery(['tag', { id }], api.tags.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    tag: queryResult.data || {},
    ...queryResult,
  };
};
